import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-343c725a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "series-data" }
const _hoisted_2 = { class: "menu flex" }
const _hoisted_3 = { class: "values flex" }
const _hoisted_4 = { class: "value-panel-heading" }
const _hoisted_5 = { class: "value-panel-body" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))
const _hoisted_8 = { class: "value-panel value-panel-current" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-panel-heading" }, "現在", -1))
const _hoisted_10 = { class: "value-panel-body" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))
const _hoisted_13 = { class: "value-panel value-panel-current" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value-panel-heading" }, "積算値", -1))
const _hoisted_15 = { class: "value-panel-body" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "mm", -1))

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import moment, { Moment } from 'moment'
import { times } from 'lodash'
import { Resolution } from '@/lib/constants'
import { useRainDetailStore } from '@/stores/rainDetailStore'
import { usePresentStore } from '@/stores/presentStore'
import { HistoryItem } from '@/models/History'
import { useGlobalStore } from '@/stores/globalStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const FETCH_INTERVAL = 60 * 1000 // 1分
const HISTORY_DATA_NUM = 6
const globalStore = useGlobalStore()
const rainDetailStore = useRainDetailStore()
const presentStore = usePresentStore()
const stationId = computed(() => {
  return globalStore.currentStation?.stationId
})

const route = useRoute()
const currentData = computed(() => {
  return presentStore.findByStationId(stationId.value)
})
const resolution = ref<string>('hour')
const fetch = () => {
  const id = stationId.value || (route.params.stationId as string)

  if (fetchTime.value) {
    rainDetailStore.fetch(id, fetchTime.value)
  }
}

onMounted(() => {
  fetch()

  setInterval(fetch, FETCH_INTERVAL)
})

const unit = computed(() => {
  return resolution.value === 'hour' ? 'minutes' : resolution.value === 'day' ? 'hour' : 'day'
})

const historyData = computed(() => {
  if (!fetchTime.value) {
    return []
  }

  const min = Math.floor(moment(fetchTime.value).add(-1, 'minute').minutes() / 10) * 10
  const hour = moment(fetchTime.value).add(-1, 'minute').hour()
  const now = moment(fetchTime.value).set('minutes', min).set('hours', hour)
  const data = [] as {
    time: string
    value: string
  }[]
  const resolutionKey = resolution.value as 'hour' | 'day' | 'month'
  const tmpData = rainDetailStore[resolutionKey]
  const span = resolution.value === 'hour' ? -10 : -1

  times(HISTORY_DATA_NUM, index => {
    const tmpTime = moment(now).add(span * index, unit.value)
    const targetDate = historyStatusTimeFormatter(tmpTime)

    const datum = tmpData.find(d => historyStatusTimeFormatter(d.time) === targetDate)
    const value = datum && getValue(datum)

    data.unshift({
      time: targetDate,
      value: !datum || value === undefined || value === null ? '-' : value.toFixed(1),
    })
  })

  return data
})

const currentValue = computed(() => {
  const value =
    resolution.value === 'hour'
      ? currentData.value?.rainMin10
      : resolution.value === 'day'
      ? currentData.value?.rainMin60
      : currentData.value?.rainDay

  return value
})

const fetchTime = computed(() => {
  if (stationId.value !== route.params.stationId) {
    return
  }

  if (!currentData.value?.time) {
    return
  }

  return moment(currentData.value.time).format()
})

const sumValue = computed(() => {
  const current = currentValue.value || 0
  const key = resolution.value as 'hour' | 'day' | 'month'

  return (
    rainDetailStore[key].reduce((memo: number, datum: HistoryItem) => {
      const value = getValue(datum) || 0

      return memo + value
    }, 0) + current
  )
})

const handleClickMenuItem = (target: string) => {
  resolution.value = target
  fetch()
}

const getValue = (item: HistoryItem) => {
  if (resolution.value === 'hour') {
    return item.moveRainMin10
  } else if (resolution.value === 'day') {
    return item.moveRainMin60
  } else {
    return item.rainDay
  }
}

const menuItemClass = (target: Resolution) => {
  return target === resolution.value && 'active'
}

const historyStatusTimeFormatter = (dateStr: string | Moment) => {
  const format = resolution.value === 'month' ? 'MM/DD' : resolution.value === 'day' ? 'HH:00' : 'HH:mm'
  const result = moment(dateStr)

  if (resolution.value !== 'month') {
    return result.format(format)
  }

  return result.add(-1, 'day').format(format)
}

watch(fetchTime, fetch)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClickMenuItem('hour'))),
        class: _normalizeClass([menuItemClass('hour'), "menu-item flex flex-center"])
      }, " 10分積算雨量 ", 2),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClickMenuItem('day'))),
        class: _normalizeClass([menuItemClass('day'), "menu-item flex flex-center"])
      }, " 1時間積算雨量 ", 2),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleClickMenuItem('month'))),
        class: _normalizeClass([menuItemClass('month'), "menu-item flex flex-center"])
      }, " 日積算雨量 ", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historyData), (datum, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "value-panel"
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(datum.time), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(datum.value), 1),
            _hoisted_7
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(currentValue) === null || _unref(currentValue) === undefined ? '-' : _unref(currentValue).toFixed(1)), 1),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(sumValue).toFixed(1)), 1),
          _hoisted_17
        ])
      ])
    ])
  ]))
}
}

})